import { render, staticRenderFns } from "./employer-video-ads-list.vue?vue&type=template&id=479cfc37&scoped=true"
import script from "./employer-video-ads-list.vue?vue&type=script&lang=js"
export * from "./employer-video-ads-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479cfc37",
  null
  
)

export default component.exports